import { render, staticRenderFns } from "./componentsidebar.vue?vue&type=template&id=005006cc"
import script from "./componentsidebar.vue?vue&type=script&lang=js"
export * from "./componentsidebar.vue?vue&type=script&lang=js"
import style0 from "./componentsidebar.vue?vue&type=style&index=0&id=005006cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports